import React, {Component} from "react";
import ReactDOM from "react-dom";

class MapDemonHeader extends Component {
  render() {
    return (
      <div className="header">
        <h1>Map Demon: Overworld Map Creator</h1>
        <h2>Currently in sporadic development.</h2>
      </div>
    );
  }
}

export default MapDemonHeader;



// WEBPACK FOOTER //
// ./src/MapDemonHeader.js